/** Angular core modules */
import {
  NgModule,
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";

/** Routes */
import { AppRoutingModule } from "./app-routing.module";

/** Modules */
import { AppComponent } from "./app.component";
import { AuthModule } from "@app/auth/auth.module";

import { ComponentsModule } from "@shared/components";
import { ContainersModule } from "@shared/containers";
import { ErrorsModule } from "@app/shared/errors";
import { HttpServiceModule } from "@shared/async-services/http";
import { UtilityModule } from "@shared/utility";
/** guards */
import { AuthGuard } from "@shared/guards/auth.guard";
import { CanDeactivateGuard } from "@shared/guards/can-deactivate.guard";
/** Services */
import { ConfigService } from "./app-config.service";
/** Third party modules */
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { SimpleNotificationsModule } from "angular2-notifications";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { JwtModule } from "@auth0/angular-jwt";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSelectModule } from "@angular/material/select";
import { MatMenuModule } from "@angular/material/menu";
import { MatInputModule } from "@angular/material/input";
import { MatExpansionModule } from '@angular/material/expansion';
import {
  MatFormFieldModule,
} from "@angular/material/form-field";

import { FullComponent } from "./shared/layouts/full/full.component";
import { BlankComponent } from "./shared/layouts/blank/blank.component";

import { NavigationComponent } from "./shared/header-navigation/navigation.component";
import { SidebarComponent } from "./shared/sidebar/sidebar.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ToastrModule } from "ngx-toastr";
import { ChangeLogComponent } from "./change-log/change-log.component";
import { ConfirmDialogService } from "@shared/confirm-dialog/confirm-dialog.service";
import { LogService } from './shared/async-services/logger/logger.service';
import { Requestutility } from "@shared/utility/request.utlity";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { NgxFileDropModule } from "ngx-file-drop";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { ConfirmDialogComponent } from "@shared/confirm-dialog/confirm-dialog.component";
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from 'primeng/button';
import { AssignedAccountantComponent } from './assigned-accountant/assigned-accountant.component';
import { MatButtonModule } from "@angular/material/button";
import { MatListModule } from '@angular/material/list'
import { DashBoardFooterComponent } from "@shared/components/dashboardfooter/dashboardfooter.component";
import { UserComponent } from "./features-modules/superadmin/components/user/user.component";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SharedModule } from "@shared/shared.module";
import { SuperadminPageComponent } from "./features-modules/superadmin/superadmin-page.component";
import { OrganizationComponent } from "./features-modules/superadmin/components/organization/organization.component";
import { InquiryPageComponent } from './static-pages/inquiry-page/inquiry-page.component';
import { AboutUsComponent } from './static-pages/about-us/about-us.component';
import { TermsConditionComponent } from './static-pages/terms-condition/terms-condition.component';
import { MatTooltipModule } from "@angular/material/tooltip";
import { CommonService } from "@shared/services/common.service";
import { CookieService } from 'ngx-cookie-service';
// import { DndDirective } from "./features-modules/medication/components/import-medication/dnd.directive";
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { CanLogoutClientGuard } from "@shared/guards/can-logout-client.guard";
import { CanLogoutSAGuard } from "@shared/guards/can-logout-sa.guard";
import { CanLogoutAccountantGuard } from "@shared/guards/can-logout-accountant.guard";
import { CanLogoutCAGuard } from "@shared/guards/can-logout-ca.guard";
import { DropdownModule } from 'primeng/dropdown';
import { VenaqiServicesComponent } from './static-pages/venaqi-services/venaqi-services.component';
import { VenaqiServiceTwoComponent } from './static-pages/venaqi-service-two/venaqi-service-two.component';
import { MentionsLegalesComponent } from './static-pages/mentions-legales/mentions-legales.component';
import { PrivacyPolicyComponent } from './static-pages/privacy-policy/privacy-policy.component';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "@env/environment";
import { EditAccuserComponent } from "./features-modules/chief-accountant/components/edit-accuser/edit-accuser.component";
import { MultiSelectAllModule } from "@syncfusion/ej2-angular-dropdowns";
import { CheckBoxModule } from "@syncfusion/ej2-angular-buttons";
import { NumericTextBoxModule } from "@syncfusion/ej2-angular-inputs";
import { ClientFeedbackSubmitComponent } from "./features-modules/client/client-feedback-submit/client-feedback-submit.component";
import { CaEvaluationDetailComponent } from "./features-modules/chief-accountant/ca-evaluation-detail/ca-evaluation-detail.component";
import { CaAnnualEvaluationComponent } from './chief-accountant/ca-annual-evaluation/ca-annual-evaluation.component';

/**
 * Calling functions or calling new is not supported in metadata when using AoT.
 * The work-around is to introduce an exported function.
 *
 * The reason for this limitation is that the AoT compiler needs to generate the code that calls the factory
 * and there is no way to import a lambda from a module, you can only import an exported symbol.
 */

export function configServiceFactory(config: ConfigService) {
  return () => config.load();
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function tokenGetter() {
  return localStorage.getItem("id_token");
}

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.CLIENT_ID, // PPE testing environment
      authority: environment.AUTHORITY, // PPE testing environment.
      redirectUri: environment.REDIRECT_URI,
      postLogoutRedirectUri: environment.POST_LOGOUT_REDIRECT_URI
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      allowRedirectInIframe: true,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();  
  protectedResourceMap.set(environment.AUTHORITY, [environment.SCOPES]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.SCOPES]
    },
    loginFailedRoute: '/login-failed'
  };
}
@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    SidebarComponent,
    ChangeLogComponent,
    LandingPageComponent,
    AssignedAccountantComponent,
    DashBoardFooterComponent,
    SuperadminPageComponent,
    OrganizationComponent,
    UserComponent,
    InquiryPageComponent,
    AboutUsComponent,
    TermsConditionComponent,
    VenaqiServicesComponent,
    VenaqiServiceTwoComponent,
    MentionsLegalesComponent,
    PrivacyPolicyComponent,
    EditAccuserComponent,
    ClientFeedbackSubmitComponent,
    CaAnnualEvaluationComponent,
  ],
  imports: [
    /** Angular core dependencies */
    BrowserModule,
    HttpClientModule,
    MsalModule,

    /** App custom dependencies */
    AuthModule,
    AppRoutingModule,
    MatIconModule,
    ComponentsModule,
    ContainersModule,
    ErrorsModule,
    HttpServiceModule.forRoot(),
    UtilityModule.forRoot(),
    MatToolbarModule,
    MatSidenavModule,
    MatSelectModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    FontAwesomeModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    NgxFileDropModule,
    MatAutocompleteModule,
    FormsModule,
    MatListModule,
    MatButtonModule,
    MatTooltipModule,
    MultiSelectAllModule,
    CheckBoxModule,
    NumericTextBoxModule,
    MatExpansionModule,
    //primeng
    DialogModule,
    ButtonModule,
    CarouselModule,
    SharedModule,
    DropdownModule,
    MatProgressSpinnerModule,
    /** Third party modules */
    NgbModule,
    SimpleNotificationsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ["localhost:3000","34.201.91.58:8081"],
        disallowedRoutes: [
          "/config/env.json",
          "/config/development.json",
          "/config/production.json",
          "/assets/i18n/en.json",
          "localhost:3000/auth/",
        ],
      },
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot()    
  ],
  providers: [
    AuthGuard,
    CanDeactivateGuard,
    ConfigService,
    ConfirmDialogService,
    Requestutility,
    CommonService,
    CookieService,
    CanLogoutClientGuard,
    CanLogoutSAGuard,
    CanLogoutAccountantGuard,
    CanLogoutCAGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: configServiceFactory,
      deps: [ConfigService],
      multi: true,
    },
    LogService,
    {provide : LocationStrategy , useClass: HashLocationStrategy},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  

  bootstrap: [AppComponent, MsalRedirectComponent],
  entryComponents:[ConfirmDialogComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
